<template>
  <BasePopup
    title="êtes-vous sûr ?"
    close-button
    footer-required
    @close="$emit('close', $event)"
  >
    <div
      class="dc-wrap"
      :class="{'small-width': smallWidth}"
    >
      <div class="dc-text text-gray translate">
        <slot />
      </div>
      <FygrInput
        v-if="popupType === 'delete'"
        v-model="text"
        class="dc-input"
        :label="`Entrer ${supprimerTranslated} pour confirmer`"
        :placeholder="supprimerTranslated"
        :spellcheck="false"
        :value-in="text"
        exclude-translation
        @next="
          text !== supprimerTranslated || deleting
            ? () => true
            : $emit('confirmed')
        "
      />
      <FygrInput
        v-else
        v-model="text"
        class="dc-input"
        :label="`Entrer ${confirmerTranslated} pour confirmer`"
        :placeholder="confirmerTranslated"
        :spellcheck="false"
        :value-in="text"
        @next="
          text !== confirmerTranslated || deleting
            ? () => true
            : $emit('confirmed')
        "
      />
    </div>
    <template #footer>
      <div class="dc-controls">
        <FygrButton
          class="dc-confirm"
          :color="buttonColor"
          :disabled="
            (text !== supprimerTranslated && text !== confirmerTranslated) ||
            deleting
          "
          :loading="deleting"
          @fygr-click="$emit('confirmed')"
        >
          {{ buttonName }}
        </FygrButton>
        <a
          class="text-blue clickable translate"
          @click="$emit('close')"
        >
          Annuler
        </a>
      </div>
    </template>
  </BasePopup>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {SUPPRIMERTRANSLATED} from '@/data/locales';
import {CONFIRMERTRANSLATED} from '@/data/locales';

export default {
  name: 'DeleteConfirmationPopup',
  props: {
    buttonName: {
      type: String,
      default: 'Supprimer',
    },
    buttonColor: {
      type: String,
      default: 'red',
    },
    popupType: {
      type: String,
      default: 'delete',
    },
    deleting: Boolean,
    smallWidth: Boolean,
  },
  emits: ['confirmed', 'close'],
  data() {
    return {
      text: '',
      titleTranslated: `Entrer 55 pour confirmer`,
    };
  },
  computed: {
    ...mapGetters('user', ['getLocale']),
    supprimerTranslated() {
      return SUPPRIMERTRANSLATED[this.getLocale.toUpperCase()];
    },
    confirmerTranslated() {
      return CONFIRMERTRANSLATED[this.getLocale.toUpperCase()];
    },
  },
  async mounted() {
    this.titleTranslated = await this.actionTranslatePhrase(
      'Entrer 55 pour confirmer',
    );
  },
  methods: {
    ...mapActions('translations', ['actionTranslatePhrase']),
  },
};
</script>
<style lang="scss" scoped>
.dc-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: var(--px350);
  width: var(--px500);
  &.small-width {
    width: 282px;
    min-width: 282px;
    flex: 0;
    .dc-text {
      margin: 0;
    }
  }
  .dc-title {
    margin-bottom: var(--px60);
  }
  .dc-text {
    margin: 0 var(--px30);
  }
  .dc-input {
    margin-top: var(--px40);
    width: var(--px280);
  }
}
.dc-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  .dc-confirm {
    padding: 0 var(--px30);
    height: var(--px40);
    margin-bottom: var(--px15);
  }
}
</style>
